import React from 'react';
import recruit from "./assets/i/monsters/POSSA1.png";
import conscript from "./assets/i/monsters/SPOSA1.png";
import orc from "./assets/i/monsters/TROOA1.png";
import kadyrovite from "./assets/i/monsters/SARGA1.png";
import wagner from "./assets/i/monsters/SKULA1.png";
import Sergey from "./assets/i/monsters/HEADA1.png";
import airborn from "./assets/i/monsters/BOSSA1.png";
import putin from "./assets/i/monsters/CYBRA1.png";
import btr from './assets/i/monsters/BTR.png';
import { useTranslation } from 'react-i18next';

const ListEnnemies = () => {
    const { t } = useTranslation();

    return (

        <dl>
            <div className="row">
                <dt>
                    <img alt={t('conscript')} src={recruit} />
                </dt>
                <dd>
                    <h3>{t('conscript')}</h3>
                    <p>{t('Young entusiast russian')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt="{t('soldier')}" src={conscript} />
                </dt>
                <dd>
                    <h3>{t('soldier')}</h3>
                    <p>{t('They survived where')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt="orc" src={orc} />
                </dt>
                <dd>
                    <h3>Orcs</h3>
                    <p>{t('Backbone of the Putin')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt="kadyrovite" src={kadyrovite} />
                </dt>
                <dd>
                    <h3>{t('Kadyrovtsy')}</h3>
                    <p>{t('Brutal beasts')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t('Lost soul of Wagnerites')} src={wagner} />
                </dt>
                <dd>
                    <h3>{t('Lost soul of Wagnerites')}</h3>
                    <p>{t('They have been wandering')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t('Caco Lavrov')} src={Sergey} />
                </dt>
                <dd>
                    <h3>{t('Caco Lavrov')}</h3>
                    <p>{t('This creature of evil')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t('Airborn')} src={airborn} />
                </dt>
                <dd>
                    <h3>{t('Airborn')}</h3>
                    <p>{t('They are among the most competent')}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt={t("Cyber Putin")} src={putin} />
                </dt>
                <dd>
                    <h3>{t("Cyber Putin")}</h3>
                    <p>{t("This monstruous creature of war")}</p>
                </dd>
            </div>
            <div className="row">
                <dt>
                    <img alt="btr" src={btr} />
                </dt>
                <dd>
                    <h3>BTR</h3>
                    <p>{t("This BTR will fire at you as much as it can!")}</p>
                </dd>
            </div>
        </dl>
    );
}

export default ListEnnemies;

